module.exports = __webpack_public_path__ + "img/promo-push-config.d03bc275.png";